<!-- Toast Messages - For failed cases only -->
<p-toast
  data-testid="warehouse-form-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [life]="6000"
  [preventDuplicates]="false"
></p-toast>

<app-add-form
  data-testid="warehouse-form-add-form"
  [title]="formConfig().title"
  [formFields]="formConfig().formFields"
  [headerActions]="formConfig().headerActions"
  [sectionButtons]="formConfig().sectionButtons"
  [tableSections]="formConfig().tableSections"
  [editMode]="isEditMode()"
  [viewMode]="false"
  [initialData]="warehouseData()"
  [loading]="loading()"
  [height]="'100%'"
  (formAction)="onFormAction($event)"
  (sectionAction)="onSectionAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
  (tableAction)="onTableAction($event)"
>
</app-add-form>
